import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import HomePage from './pages/HomePage';
import BlogPage from './pages/BlogPage';
import AuditPage from './pages/AuditPage';
import AboutPage from './pages/AboutPage';
import CareerPage from './pages/CareerPage';
import CooperationModelPage from './pages/CooperationModelPage';
import AdminPage from './pages/AdminPage';
import Article1Page from './pages/blog/Article1Page';
import Article2Page from './pages/blog/Article2Page';
import Article3Page from './pages/blog/Article3Page';

gsap.registerPlugin(ScrollTrigger);

function App() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    
    const timer = setTimeout(() => {
      ScrollTrigger.refresh();
    }, 100);

    return () => {
      clearTimeout(timer);
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="relative min-h-screen overflow-x-hidden">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/ai-meni-vysledky-vyhledavani" element={<Article1Page />} />
          <Route path="/blog/proc-lide-budou-vic-vyuzivat-ai-vyhledavani" element={<Article2Page />} />
          <Route path="/blog/ai-seo-bez-chaosu-prvni-mesic" element={<Article3Page />} />
          <Route path="/audit" element={<AuditPage />} />
          <Route path="/o-nas" element={<AboutPage />} />
          <Route path="/kariera" element={<CareerPage />} />
          <Route path="/model-spoluprace" element={<CooperationModelPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
